import { render, staticRenderFns } from "./BirthdayOffer.vue?vue&type=template&id=1066c9ea&"
import script from "./BirthdayOffer.vue?vue&type=script&lang=ts&"
export * from "./BirthdayOffer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports